import { crpCommunicationsCuratedBaseApi } from "./crpCommunicationsBaseApi";


const sendMailPath = "/email"

export const sendMailApi = crpCommunicationsCuratedBaseApi.injectEndpoints({
    endpoints: build => ({
        sendMailFromCRP: build.mutation({
            query: (body) => {
                return {
                    url: sendMailPath,
                    method: 'POST',
                    body
                }
            }
        })
    })
})


export const { useSendMailFromCRPMutation } = sendMailApi